<template>
  <section>
    <h1 class="text-h3 mb-8">
      Menus
    </h1>
    <v-sheet
      class="d-flex justify-space-around mb-4 px-6 py-4"
      outlined
      rounded
    >
      <v-menu offset-y>
        <template #activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            General menu
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="i in 10"
            :key="i"
            link
          >
            <v-list-item-title>Item {{ i }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu offset-y>
        <template #activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            HTML Contents
          </v-btn>
        </template>
        <div class="white pa-4">
          <v-icon
            left
          >
            fa-solid fa-circle-info
          </v-icon>
          HTML contents.
        </div>
      </v-menu>
      <v-menu
        open-on-hover
        offset-y
        top
      >
        <template #activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            Open on hover
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="i in 10"
            :key="i"
            link
          >
            <v-list-item-title>Item {{ i }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-sheet>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/components/menus/">
      <strong>Menus</strong>
    </external-link>
    <external-link href="https://vuetifyjs.com/en/components/lists/">
      <strong>Lists</strong><br>
      Using menu with list items.
    </external-link>
  </section>
</template>

<script>
export default {
  name: 'ComponentsMenus'
}
</script>
